import React from 'react';
import PropTypes from 'prop-types';

import TmntText from '../tmnt-text/tmnt-text';

export default function ExchangeButton({
  product,
  k = null,
}) {
  return (
    <button
      type="button"
      className="button product-quickview__button exchanges-quickview__button exchange-button"
      data-productid={product.productId}
      data-item-id={product.orderLineKey}
      data-sku={product.partNumber}
      data-seq="0"
      data-collectionid={product.collection}
    >
      <TmntText k={k || 'RNE_RETURNSFLOW_CHANGE'} />
    </button>
  );
}

ExchangeButton.propTypes = {
  product: PropTypes.shape({
    productId: PropTypes.string,
    orderLineKey: PropTypes.string,
    partNumber: PropTypes.string,
    collection: PropTypes.string,
  }).isRequired,
  k: PropTypes.string,
};
